/**
 * Screen 1 - Introduction and aspect selection.
 */
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import zipObject from 'lodash/zipObject';
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import { DropdownList } from 'react-widgets';
import ButtonNext from './ButtonNext';

function Intro({
  goalCategories,
  nextStep,
  paragraphData,
  resultCategory,
  setCategory,
}) {
  const { fieldText, fieldWhatMakesAGoodGoal } = paragraphData;
  // Key and sort category taxonomy for use with the dropdownlist
  const categoryData = sortBy(map(goalCategories, (termName, tid) =>
    zipObject(['id', 'name'], [tid, termName]),
  ), ['name']);
  const infoBoxes = fieldWhatMakesAGoodGoal.map((entity, index) =>
    <li
      key={`li-${index}`}
      dangerouslySetInnerHTML={{ __html: entity.value }}
    />,
  );
  return (
    <div
      className={classnames({
        'goal--step-one': true,
      })}
    >
      <div className="title">
        <h4>
          Set a goal about
        </h4>
        <DropdownList
          data={categoryData}
          onChange={setCategory}
          placeholder="choose a topic"
          textField={'name'}
          value={resultCategory}
          valueField={'id'}
        />
      </div>
      <div
        className={classnames({
          description: true,
        })}
        dangerouslySetInnerHTML={{
          __html: fieldText[0].value,
        }}
      />
      <ul
        className={classnames({
          boxes: true,
        })}
      >
        {infoBoxes}
      </ul>
      <ButtonNext
        buttonText={paragraphData.fieldButtonText[0].value}
        disabled={!resultCategory}
        nextStep={nextStep}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Step 1 of 10
      </div>
    </div>
  );
}

Intro.propTypes = {
  goalCategories: PropTypes.shape({}),
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  resultCategory: PropTypes.shape({}),
  setCategory: PropTypes.func,
};

export default Intro;



// WEBPACK FOOTER //
// js/src/goals/Intro.js